import React from 'react';
import {view} from '@sail/ui';
import {qrCode} from '@sail/icons/react/Icon';
import {ChipButton, Text} from 'src/v2/components/common';
import {useAmountDisplay} from 'src/v2/state/useAmountDisplay';
import {message, useIntl} from '@sail/intl';

interface Props {
  onDirectDepositPress?: () => void;
}

const messages = {
  noWalletFound: message({
    id: 'crypto.payins.v2.wallet_select_list.no_wallet_found',
    description: 'Message when no wallets match the search query',
    defaultMessage: 'No wallet found',
  }),
  noWalletFoundDirectDepositDescription: message<{
    amount: React.ReactNode;
  }>({
    id: 'crypto.payins.v2.wallet_select_list.search_no_wallet_direct_deposit',
    description:
      'Description suggesting direct deposit when no wallet search results',
    defaultMessage:
      'You can still complete this payment by sending {amount} via direct deposit.',
  }),
  directDeposit: message({
    id: 'crypto.payins.v2.wallet_select_list.direct_deposit',
    description:
      'Label for the direct deposit via QR code option in the wallet select UI',
    defaultMessage: 'Direct deposit via QR code',
  }),
};

export const WalletSelectListEmpty = ({onDirectDepositPress}: Props) => {
  const intl = useIntl();
  const formattedAmount = useAmountDisplay();

  return (
    <view.div
      css={{stack: 'y', gap: 'xsmall', alignX: 'center', alignY: 'center'}}
    >
      <Text type="mediumEmphasized">
        {intl.formatMessage(messages.noWalletFound)}
      </Text>
      {onDirectDepositPress ? (
        <view.div css={{stack: 'y', gap: 'large', alignX: 'center'}}>
          <Text type="body" css={{textAlign: 'center'}}>
            {intl.formatMessage(
              messages.noWalletFoundDirectDepositDescription,
              {amount: formattedAmount},
            )}
          </Text>
          <ChipButton
            icon={qrCode}
            onClick={onDirectDepositPress}
            label={intl.formatMessage(messages.directDeposit)}
          />
        </view.div>
      ) : null}
    </view.div>
  );
};
